module.exports = __webpack_public_path__ + "fonts/GothamSSm-BookItalic.fc0259f8.eot";